<template>
  <div class="position-relative" v-click-outside="hide">
    <div class="d-flex align-items-center" @click="open">
      <img src="/images/funnel_grey.svg" alt="" v-if="selected.length === 0">
      <img src="/images/funnel_green.svg" alt="" v-else>
      <span class="adp-p adp-p__bold" :class="{'adp-p__grey': selected.length === 0, 'adp-p__green' : selected.length > 0}">
        {{ $t('idp.filter_event_by_status') }}
      </span>
    </div>
    <div v-if="isVisible">
      <div class="position-absolute adp-dd-options">
        <div class="d-flex flex-column">
          <div class="adp-p adp-dd-option d-flex align-items-center">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" :id="`customCheckMethod`" v-model="allSelected" @change="toggleAll($event)" v-if="hasSelectAll">
              <label class="custom-control-label" :for="`customCheckMethod`">{{ $t('catalog.all') }}</label>
            </div>
          </div>
          <div class="adp-p adp-dd-option" v-for="(option, i) in options">
            <div class="custom-control custom-checkbox d-flex align-items-center">
              <input type="checkbox" class="custom-control-input" :id="`customCheckMethod${option.id}`" v-model="selected" :value="option.id">
              <label class="custom-control-label" :for="`customCheckMethod${option.id}`">
                {{ option.wish ? $t(`idp.assigned_for_wish`) : $t(`idp.${option.code}`) }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {updateUrl} from "../updateUrl";

export default {
  name: 'MyTaskFilter',
  props: {
    hasSelectAll: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    initSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: this.initSelected,
      allSelected: false,
      indeterminate: false,
      isVisible: false,
      text: '',
    };
  },
  watch: {
    selected(newVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
        this.text = '';
        this.updateUrl({la_s: null});
      } else if (newVal.length === this.options.length) {
        this.indeterminate = false;
        this.allSelected = true;
        this.text = this.options.map(element => element.text).join(', ');
        this.updateUrl({la_s: this.selected.join('0')});
      } else {
        this.indeterminate = true;
        this.allSelected = false;
        this.text = this.options
          .map(element => (newVal.slice().includes(element.id) ? element.text : false))
          .filter(element => element)
          .join(', ');
        this.updateUrl({la_s: this.selected.join('0')});
      }
      this.$emit('my-change', this.selected);
    },
  },
  methods: {
    toggleAll(e) {
      this.selected = e.target.checked ? this.options.map(element => element.id) : [];
    },
    hide() {
      this.isVisible = false;
    },
    open() {
      this.isVisible = true;
    },
    ok() {
      this.hide();
      this.$emit('my-change', this.selected);
    },
    updateUrl(params) {
      updateUrl(params);
    }
  },
  mounted() {
    this.text = this.options
      .map(element => (this.initSelected.slice().includes(element.id) ? element.text : false))
      .filter(element => element)
      .join(', ');

    this.popupItem = this.$el;
  },
};
</script>

<style scoped>
>>> .adp-dd-options {
  max-width: 280px;
}
</style>
